import { motion } from "framer-motion";

const ORDER = ["home", "first", "second", "third", "home"];
const OCCUPIED = [["first", 1], ["second", 2], ["third", 4]];

const route = (src, dst, bases) => {
  const start = ORDER.indexOf(src);
  const end = dst === "home" ? 4 : ORDER.indexOf(dst);
  if (end <= start) return [bases[src]];
  return ORDER.slice(start, end + 1).map((b) => bases[b]);
};

export const Runners = ({ cfg, runners, paths, hitId, size, still }) => {
  const { bases } = cfg;
  const ring = { fill: "none", stroke: "var(--runner)", strokeWidth: size * 0.32, r: size * 1.45 };
  const list = OCCUPIED.filter(([, bit]) => runners & bit).map(([base]) => base);
  const moving = hitId ? paths : [];
  const batter = moving.find((p) => p.src === "home");
  return (
    <g style={{ pointerEvents: "none" }}>
      {[...(batter ? ["home"] : []), ...list].map((base) => {
        const id = base === "home" ? "batter" : base === "first" ? "1b" : base === "second" ? "2b" : "3b";
        const path = moving.find((p) => p.src === base);
        if (!path) {
          return <circle key={base} data-testid={`runner-on-${id}`} className="runner-ring" cx={bases[base][0]} cy={-bases[base][1]} {...ring} />;
        }
        const pts = route(path.src, path.dst, bases);
        const end = pts[pts.length - 1];
        if (still) return <circle key={base} data-testid={`runner-on-${id}`} cx={end[0]} cy={-end[1]} {...ring} />;
        return (
          <motion.circle
            key={`${base}-${path.dst}-${hitId}`}
            data-testid={`runner-on-${id}`}
            data-dst={path.dst}
            {...ring}
            initial={{ cx: pts[0][0], cy: -pts[0][1] }}
            animate={{ cx: pts.map((p) => p[0]), cy: pts.map((p) => -p[1]) }}
            transition={{ duration: 0.8 + (pts.length - 2) * 0.25, ease: "easeInOut" }}
          />
        );
      })}
    </g>
  );
};
